import React from "react"
import {
  Switch,
  Route,
  Redirect,
  useLocation
} from "react-router-dom"
import ChangePassword from 'pages/ChangePassword.js'
import Test from 'pages/test.js'
import Login from 'pages/Login.js'
import Dashboard from 'pages/Dashboard.js'
import Employee from 'pages/employee/Employee.js'
import UserAccount from 'pages/employee/UserAccount.js'
import Application from 'pages/training/Application.js'
import Approval from 'pages/training/Approval.js'
import Recommend from 'pages/training/Recommend.js'
import Report from 'pages/report/Report.js'
import Sitemap from "pages/Sitemap"
import Logout from 'pages/Logout.js'
import Hazard from "pages/HSE/Hazard.js";
import HomeLeaveApplication from "pages/homeleave/HomeLeaveApplication.js";
import HomeLeaveApproval from "pages/homeleave/HomeLeaveApproval.js";
import './css/App.css'
import './css/Nav.css'
import Manpower from "pages/manpower/Manpower.js";
import Interview from "pages/interview/Interview.js";
import ManpowerApproval from "pages/manpower/ManpowerApproval"
import InterviewApproval from "pages/interview/InterviewApproval"
import InterviewRecommend from "pages/interview/InterviewRecommend"
import StaffAppraisal from "pages/appraisal/StaffAppraisal";
import ManagerApproval from "pages/appraisal/ManagerApproval";
import DirectorApproval from "pages/appraisal/DirectorApproval";
import SupervisorAppraisal from "pages/appraisal/SupervisorAppraisal";
import AppraisalSetupContainer from "pages/appraisal/AppraisalSetup";
import Helpdesk from "pages/support/Helpdesk";
import Requisition from "pages/support/ItRequisition";
import RequisitionApproval from "pages/support/ItRequisitionApproval";
import FixedAsset from "pages/support/FixedAsset";
import InvoiceApplication from "pages/finance/invoiceApplication";
import MergedApplication from "pages/finance/MergedApplication";
import DoApplication from "pages/finance/DoApplication";
import InvoiceApplicationManagerApproval from "pages/finance/InvoiceApplicationManagerApproval";
import InvoiceApplicationDirectorApproval from "pages/finance/InvoiceApplicationDirectorApproval";


const path = process.env.REACT_APP_PATH
const domain = process.env.REACT_APP_DOMAIN

// Top level routes are contained here, other pages may have their own routes

function Routes({ authenticated,authorized, companyCode, destroySession }) {

  
  if (authorized) {
  
    return (
      <Switch>
        <Route exact path={path + "/changepassword"}>
          <ChangePassword
            authorized={authenticated}
          />
        </Route>
        {/* <Route exact path={path +path + "/"}>
          <Redirect to={path +path + "/db"} />
        </Route> */}
        <Route path={path + "/manpower"}>
          <Manpower />
        </Route>
        <Route path={path + "/manpowerApproval"}>
          <ManpowerApproval />
        </Route>
        <Route path={path + "/interviewApproval"}>
          <InterviewApproval />
        </Route>
        <Route path={path + "/interviewRecommend"}>
          <InterviewRecommend />
        </Route>
        <Route path={ path + "/interview"}>
          <Interview />
        </Route>
        <Route path={path + "/sa"}>
          <StaffAppraisal />
        </Route>
        <Route path={path + "/ma"}>
          <ManagerApproval />
        </Route>
        <Route path={path + "/da"}>
          <DirectorApproval />
        </Route>
        <Route path={path + "/supera"}>
          <SupervisorAppraisal />
        </Route>
        <Route path={path + "/sasetup"}>
          <AppraisalSetupContainer />
        </Route>
         <Route path={path + "/scan-invoice"}>
          <InvoiceApplication />
        </Route>
        <Route path={path +  "/scan-do"}>
          <DoApplication />
        </Route>
        <Route path={path + "/invoice-ma-approval"}>
          <InvoiceApplicationManagerApproval />
        </Route>
        <Route path={path + "/invoice-da-approval"}>
          <InvoiceApplicationDirectorApproval />
        </Route>
        <Route path={ path + "/merge-file"}>
          <MergedApplication />
        </Route>
        <Route path={ path + "/db"}>
          <Dashboard />
        </Route>
        <Route path={path + "/employee"}>
          <Employee />
        </Route>
        <Route path={path + "/useraccount"}>
          <UserAccount />
        </Route>
        <Route path={path + "/application"}>
          <Application />
        </Route>
        <Route path={path + "/approval"}>
          <Approval />
        </Route>
        <Route path={path + "/recommend"}>
          <Recommend />
        </Route>
        <Route path={path + "/hd"}>
          <Helpdesk />
        </Route>
        <Route path={path + "/itreq"}>
          <Requisition />
        </Route>
        <Route path={path + "/itapp"}>
          <RequisitionApproval />
        </Route>
        <Route path={path + "/fa"}>
          <FixedAsset />
        </Route>
        <Route path={path + "/report"}>
          <Report />
        </Route>
        <Route path={ path + "/homeleaveapplication"}>
          <HomeLeaveApplication />
        </Route>
        <Route path={ path +  "/homeleaveapproval"}>
          <HomeLeaveApproval />
        </Route>
        <Route path={path + "/hazard"}>
          <Hazard />
        </Route>
        <Route path={ path + "/sitemap"}>
          <Sitemap />
        </Route>
        <Route exact path={path + "/logout"}>
          <Logout destroySession={destroySession} />
        </Route>
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    )
  } else {
  
    return <Redirect to={path + "/login"} />
  }


}

    
function PageNotFound() {
  let location = useLocation()
  return (
    <div>
      <div className="dark-bg"></div>
      <div id="error-box">404 Page not found for <code>{location.pathname}</code></div>
    </div>
  )
}

export default Routes
